import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ion-text-wrap" }

import {
  IonContent, IonHeader, IonPage, IonButtons, IonMenuButton,
  IonTitle,
  IonToolbar, IonList, IonItem, IonToggle, onIonViewDidEnter,
} from '@ionic/vue';
import { ref } from 'vue';
import { subscribeToPush, isSubscribedToPush, unsubscribeFromPush } from '@/stores/user.store';
import { useAuthStore } from '@/stores/auth.store';



export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsPage',
  setup(__props) {

const auth = useAuthStore();
const notificationsEnabled = ref(false);
let initialized = false;

const enableNotificationsChanged = (e: any) => {
  //do not do anything before initialization to prevent auto-subscribe
  if (!initialized) return;

  const enabled = e.detail.checked;
  if (!(auth.userId)) {
    return;
  }

  if (enabled) {
    //subscribe
    subscribeToPush(auth.userId)
  } else {
    //Remove subscription
    unsubscribeFromPush(auth.userId)

  }
}

//load inital data when entering the tab
onIonViewDidEnter(async () => {
  if (auth.userId) {
    notificationsEnabled.value = await isSubscribedToPush(auth.userId);
    //need to enqueue the initialized flag because otherwise, it is changed before the change event
    setTimeout(() => initialized = true, 0);
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonMenuButton))
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('p.settings.title')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonList), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonItem), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonToggle), {
                    slot: "end",
                    checked: notificationsEnabled.value,
                    onIonChange: enableNotificationsChanged,
                    "helper-text": _ctx.$t('p.settings.notif.legend')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('p.settings.notif.label')), 1)
                    ]),
                    _: 1
                  }, 8, ["checked", "helper-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})